import React, { useEffect, useState } from 'react'
import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCInfoColor,
  $DCInfoLightColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  $DCWarningColor,
  $DCWarningLightColor,
  DcButton,
  DcDropDown,
  DcTag,
  PixelDate,
  PixelFlexBox,
  PixelTable,
  PixelText,
} from 'pixel-base'
import queryString from 'query-string'

import { get } from 'utils/api-routes.util'

const NotificationHistory = () => {
  const [history, setHistory] = useState([])
  const [tableLoading, setTableLoading] = useState(false)
  const p = queryString.parse(window.location.search)
  const [totalRows, setTotalRows] = useState(0)
  const [filters, setFilters] = React.useState({
    search: p.search || null,
    page: p.page || 0,
    page_size: p.page_size || 25,
    sort_by: p.sort_by || null,
    sort_order: p.sort_order || 'DESC',
    communication_type: p.communication_type || 'all',
  })

  const readData = () => {
    setTableLoading(true)
    get('/communication/queue', filters).subscribe((res: any) => {
      setTableLoading(false)
      setHistory(res.response.data || [])
      setTotalRows(res.response._meta.total)
    })
  }

  const handlePerRowsChange = async (newPerPage) => {
    setFilters({
      ...filters,
      page_size: newPerPage,
    })
  }
  const handlePageChange = (page) => {
    if (filters.page === page - 1) return
    setFilters({
      ...filters,
      page: page - 1,
    })
  }
  const handleSort = (column, sortDirection) => {
    setFilters({
      ...filters,
      sort_by: column.dataKey,
      sort_order: sortDirection === 'asc' ? 'ASC' : 'DESC',
    })
  }
  useEffect(() => {
    readData()
  }, [filters])

  const columns = [
    {
      dataKey: 'recipient',
      name: 'Recipient',
      selector: (row) => row.recipient || '--',
    },

    {
      name: 'Message',
      dataKey: 'text',
      width: '30%',
      sortable: true,
      selector: (row) => <PixelText multiLine>{row.text || '--'}</PixelText>,
    },
    {
      dataKey: 'communication_type',
      name: <PixelText multiLine>Communication Type</PixelText>,
      sortable: true,
      selector: (row) => row.communication_type || '--',
    },
    {
      dataKey: 'ack_status',
      name: <PixelText multiLine>Acknowledge Status</PixelText>,
      sortable: true,
      selector: (row) => (
        <DcTag
          customBackgroundColor={
            row.ack_status === 'sent'
              ? $DCSuccessLightColor
              : row.ack_status === 'failed'
              ? $DCDangerLightColor
              : row.ack_status === 'queued'
              ? $DCWarningLightColor
              : (row.ack_status || 'N/A') === 'N/A'
              ? $DCInfoLightColor
              : '#cc01fa'
          }
          textColor={
            row.ack_status === 'sent'
              ? $DCSuccessColor
              : row.ack_status === 'failed'
              ? $DCDangerColor
              : row.ack_status === 'queued'
              ? $DCWarningColor
              : (row.ack_status || 'N/A') === 'N/A'
              ? $DCInfoColor
              : '#cc01fa'
          }
        >
          {row.ack_status || 'N/A'}
        </DcTag>
      ),
    },

    {
      dataKey: 'status',
      name: 'Status',
      sortable: true,
      selector: (row) => (
        <DcTag
          customBackgroundColor={
            row.status === 'sent'
              ? $DCSuccessLightColor
              : row.status === 'failed'
              ? $DCDangerLightColor
              : row.status === 'queued'
              ? $DCWarningLightColor
              : $DCInfoLightColor
          }
          textColor={
            row.status === 'sent'
              ? $DCSuccessColor
              : row.status === 'failed'
              ? $DCDangerColor
              : row.status === 'queued'
              ? $DCWarningColor
              : $DCInfoColor
          }
        >
          {row.status}
        </DcTag>
      ),
    },

    {
      dataKey: 'created_at',
      name: 'Sent At',
      selector: (row) =>
        row.created_at.date ? (
          <PixelDate format="pixelStandard" value={row.created_at.date} />
        ) : (
          '--'
        ),
    },
    {
      dataKey: 'credits_consumed',
      name: <PixelText multiLine>Credits Consumed</PixelText>,
      sortable: true,
      selector: (row) => row.credits_consumed || '--',
    },
    {
      dataKey: 'customer_feedback',
      name: <PixelText multiLine>Customer Feedback</PixelText>,
      sortable: true,
      selector: (row) => (
        <PixelText multiLine>{row.customer_feedback || '--'}</PixelText>
      ),
    },
  ]

  return (
    <>
      {/* <SectionContent> */}
      <PixelFlexBox width="100%" justifyContent="flex-end">
        <PixelFlexBox
          gap="10px"
          width="30%"
          justifyContent="flex-end"
          padding="10px 0"
        >
          <DcDropDown
            placeholder="Communication Type"
            options={['all', 'sms', 'whatsapp', 'email', 'push', 'call'].map(
              (item) => {
                return {
                  label: item.charAt(0).toUpperCase() + item.slice(1),
                  value: item,
                }
              },
            )}
            value={filters.communication_type}
            onChange={(e) =>
              setFilters({ ...filters, communication_type: e.target.value })
            }
          />
          <DcButton
            variant="secondary"
            onClick={() => {
              readData()
            }}
          >
            Refresh
          </DcButton>
        </PixelFlexBox>
      </PixelFlexBox>

      <PixelTable
        columns={columns}
        data={history || []}
        progressPending={tableLoading}
        paginationServer
        paginationTotalRows={totalRows}
        paginationRowsPerPageOptions={[25, 50, 100]}
        onChangeRowsPerPage={handlePerRowsChange}
        fixedHeader
        fixedHeaderScrollHeight="calc(100vh - 470px)"
        paginationDefaultPage={Number(filters.page) + 1}
        onChangePage={handlePageChange}
        onSort={handleSort}
      />
      {/* </SectionContent> */}
    </>
  )
}

export default NotificationHistory
